import { useTranslation } from 'react-i18next'
import SearchActionsBar from '@/widgets/SearchActionsBar'
import LoadMoreSection from '@/widgets/LoadMoreSection'
import RozliczeniaTrainersTable from './components/RozliczeniaTrainersTable'
import useRozliczeniaList from './hooks/useRozliczeniaList'

export default function Rozliczenia() {
	const { t } = useTranslation()
	const {
		data,
		loading,
		loadingMore,
		totalCount,
		hasMore,
		handleLoadMore,
		handleSort,
		handleSearchChange,
		sortColumn,
		sortDirection,
		searchQuery,
	} = useRozliczeniaList()

	return (
		<>
			<div className="mb-4">
				<h1 className="text-2xl font-semibold text-gray-900">
					{t('rozliczenia.list.title')}
				</h1>
				<p className="mt-1 text-sm text-gray-500">
					{t('rozliczenia.list.subtitle')}
				</p>
			</div>

			<SearchActionsBar
				value={searchQuery}
				onChange={handleSearchChange}
				placeholder={t('rozliczenia.list.searchPlaceholder')}
				buttons={[]}
			/>

			<RozliczeniaTrainersTable
				trainers={data}
				loading={loading}
				sortColumn={sortColumn}
				sortDirection={sortDirection}
				onSort={handleSort}
			/>

			<LoadMoreSection
				hasMore={hasMore}
				loadingMore={loadingMore}
				onLoadMore={handleLoadMore}
				dataLength={data.length}
				totalCount={totalCount}
			/>
		</>
	)
}
